import React from 'react';
import styled from 'styled-components';

const DangerIcon = () => {
return(
    <Container>
        <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M7.74913 2.34977C7.95229 2.14661 8.22784 2.03247 8.51516 2.03247H17.4852C17.7725 2.03247 18.048 2.14661 18.2512 2.34977L24.5995 8.6981C24.8027 8.90127 24.9168 9.17682 24.9168 9.46414V18.4341C24.9168 18.7215 24.8027 18.997 24.5995 19.2002L18.2512 25.5485C18.048 25.7517 17.7725 25.8658 17.4852 25.8658H8.51516C8.22784 25.8658 7.95229 25.7517 7.74913 25.5485L1.4008 19.2002C1.19763 18.997 1.0835 18.7215 1.0835 18.4341V9.46414C1.0835 9.17682 1.19763 8.90127 1.4008 8.6981L7.74913 2.34977ZM8.96389 4.19914L3.25016 9.91287V17.9854L8.96389 23.6991H17.0364L22.7502 17.9854V9.91287L17.0364 4.19914H8.96389Z"
                  fill="#333333"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M17.0159 9.93327C17.4389 10.3563 17.4389 11.0423 17.0159 11.4653L10.5159 17.9653C10.0928 18.3884 9.40687 18.3884 8.9838 17.9653C8.56074 17.5423 8.56074 16.8563 8.9838 16.4333L15.4838 9.93327C15.9069 9.5102 16.5928 9.5102 17.0159 9.93327Z"
                  fill="#333333"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.9838 9.93327C9.40687 9.5102 10.0928 9.5102 10.5159 9.93327L17.0159 16.4333C17.4389 16.8563 17.4389 17.5423 17.0159 17.9653C16.5928 18.3884 15.9069 18.3884 15.4838 17.9653L8.9838 11.4653C8.56074 11.0423 8.56074 10.3563 8.9838 9.93327Z"
                  fill="#333333"/>
        </svg>

    </Container>
)

}
export default DangerIcon;

const Container = styled.div`

`;